import React, { Component } from "react";

import styles from "./pills.scss";

const closeIcon = require("../../../assets/ic_close_x.svg");

class Pills extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    let { type, on, method, name, clearRefinement } = this.props;
    let className = on ? styles.pillToggleOn : styles.pillToggleOff;
    className = type === "close" ? styles.pillClose : className;
    const onClick =
      type === "close"
        ? clearRefinement
        : evt => {
            //evt.stopPropagation()
            method(name);
          };
    return (
      <button className={className} onClick={onClick}>
        <p>
          {name}
          {type === "close" ? <span class="sr-only">- Remove Filter</span> : ""}
        </p>
      </button>
    );
  }
}

export default Pills;
